import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_AREA_REQUEST = "GET_AREA_REQUEST";
export const GET_AREA_SUCCESS = "GET_AREA_SUCCESS";
export const GET_AREA_ERROR = "GET_AREA_ERROR";

//* ACTIONS ------------------------------------------------
export const getAreaRequest = (payload = {}, callback) => ({
  type: GET_AREA_REQUEST,
  payload,
  callback,
});

export const getAreaSuccess = (data) => ({
  type: GET_AREA_SUCCESS,
  payload: data,
});

export const getAreaError = (error) => ({
  type: GET_AREA_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getAreaServiceRequest = async (areaId) => {
  const options = await withToken({
    method: Methods.GET,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(`/areas/${areaId}`, options);
};
